import { render } from "./MulQuestion.vue?vue&type=template&id=e6b5fc7c&scoped=true"
import script from "./MulQuestion.vue?vue&type=script&lang=js"
export * from "./MulQuestion.vue?vue&type=script&lang=js"

import "./MulQuestion.vue?vue&type=style&index=0&id=e6b5fc7c&scoped=true&lang=css"

import exportComponent from "E:\\VSProjects\\HTML\\quickcalculationpractice\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6b5fc7c"]])

export default __exports__